import {AppName, getAppName} from 'util/AppName'

export const CustomFieldFormScrollContentOffset = getAppName() === AppName.sheet ? 105 : -1